import {HeaderProps} from '@ui-kit/src/Header/Header.types';

import {StrapiHeaderRequest} from '@strapi/types';

export const parseStrapiHeader = ({
  logo,
  mobileMenuTitle,
  links,
}: StrapiHeaderRequest) =>
  ({
    logo: {
      href: 'https://www.rustore.ru',
      logoHref: logo?.logoHref?.url,
      afterLogoImageHref: logo?.afterLogoImageHref?.url,
    },
    links: Object.values(links).map(({isTargetBlank, ...link}) => ({
      ...link,
      target: isTargetBlank ? '_blank' : '_self',
    })),
    mobileMenu: {
      mobileMenuTitle,
    },
  }) satisfies HeaderProps;
